
export default {
  download: {
    documentTitle: 'Rota ORS',
    download: 'Baixar',
    downloadFileName: 'Nome do arquivo a ser exportado',
    downloadFormat: 'Formato para exportação',
    downloadRoute: 'Exportar rota',
    preparingDownload: 'Preparando arquivo ...',
    fileReady: 'Arquivo pronto',
    errorPreparingFile: 'Erro ao preparar arquivo',
    fileTooBigToBeDownloaded: 'Arquivo muito grande para ser baixado',
    standard: 'Padrão'
  }
}
